export default "__VITE_ASSET__BNs8R$VI__"